import { Row, Col, Modal, Form, Input, InputNumber } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { MAKE_URL } from "../../constants/conts";

const From = ({ path, sectionName, show, hide, data, refresh }) => {

  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data && Object.keys(data).length) {
      form.setFieldsValue({ ...data });
    } else {
      form.resetFields();
    }
  }, [data, form]);

  const onCreate = (values) => {
    setLoading(true);
    request({
      url: MAKE_URL(path, data),
      method: "POST",
      data: values,
      onSuccess: (d) => {
        setLoading(false);
        if (d.status) {
          ShowToast(d.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(d.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error.response?.data?.message || "Something went wrong", Severty.ERROR);
      },
    });
  };

  return (
    <Modal
      open={show}
      title={`${data ? "Update " + sectionName : "Create a New " + sectionName}`}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{ form: "credit-package", htmlType: "submit", loading }}
    >
      <Form id="credit-package" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item label="Label" name="label">
              <Input autoComplete="off" placeholder="e.g. Starter Pack" />
            </Form.Item>
          </Col>
          <Col span={12} xs={24} sm={12}>
            <Form.Item label="Credits" name="credits" rules={[{ required: true, message: "Enter number of credits" }]}>
              <InputNumber min={1} style={{ width: "100%" }} placeholder="e.g. 50" />
            </Form.Item>
          </Col>
          <Col span={12} xs={24} sm={12}>
            <Form.Item label="Amount (₹)" name="amount" rules={[{ required: true, message: "Enter amount" }]}>
              <InputNumber min={0} style={{ width: "100%" }} placeholder="e.g. 500" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default From;
